<template>
  <div class="app">
    <!-- Header -->
    <!-- <header class="header">
        <h1>My Trips</h1>
      </header> -->

    <!-- Tabs -->
    <div class="tabs">
      <button v-for="tab in tabs" :key="tab" @click="currentTab = tab"
        :class="['tab', currentTab === tab ? 'active' : '']">
        {{ tab }}
      </button>
    </div>

    <!-- Trip List -->

    <div class="container" v-if="isLoading">
      <v-skeleton-loader v-for="i in 10" :key="i" class="mt-3" type="list-item-two-line"></v-skeleton-loader>
    </div>
    <div class="container text-start" v-else>
      <v-card class="pa-4 mt-3" rounded="xl" elevation="2" v-for="trip in filteredTrips" :key="trip.id">
        <!-- Top Row -->
        <div class="d-flex justify-space-between align-start">
          <div>
            <div class="d-flex align-center">
              <v-icon size="12" color="blue">mdi-circle</v-icon>
              <span class="ml-2 font-weight-medium text-body-1">
                {{ truncate(trip.from_address) }}
              </span>
              <v-icon v-if="trip.trip_type != 2" color="#00000045" size="x-small">mdi-arrow-right</v-icon> <v-icon
                v-else size="x-small" color="#00000045">mdi-arrow-left-right</v-icon>
              <v-icon size="12" color="green">mdi-circle</v-icon>
              <span class="ml-2 font-weight-medium text-body-1">
                {{ truncate(trip.to_address) }}
              </span>
            </div>

            <div class="d-flex mt-2 text-medium-emphasis">
              <span>₹{{ trip?.discounted_amount }}</span>
            </div>
          </div>

          <span class="status" :class="intStatusToString(trip.status)" size="small">
            {{ intStatusToString(trip.status) }}
          </span>
        </div>

        <!-- Departure / Vehicle / Ride ID -->
        <div class="d-flex justify-space-between align-center mt-6">
          <div class="d-flex align-center">
            <v-icon size="32" class="mr-3" color="blue">mdi-calendar</v-icon>
            <div>
              <div class="text-caption text-medium-emphasis">Departure</div>
              <div class="text-body-2 font-weight-medium">
                {{ formatDateTime(trip.pickup_date, trip.pickup_time) }}
              </div>
            </div>
          </div>

          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-3" color="purple-lighten-5">
              <v-icon size="20" color="purple">mdi-car</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-medium-emphasis">Vehicle</div>
              <div class="text-body-2 font-weight-medium">{{ trip?.vehicle_type_id == null ? trip?.vehicle_type :
                (trip?.vehicle_type_id != null ? trip?.vehicle_type?.name : (trip?.vehicle_name ?? 'Unknown')) }}</div>
              <div class="text-caption text-medium-emphasis">Honda City</div>
            </div>
          </div>

          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-3" color="grey-lighten-4">
              <v-icon size="20">mdi-clock-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-medium-emphasis">Ride ID</div>
              <div class="text-body-2 font-weight-medium">{{ trip?.after_booking_id }}</div>
            </div>
          </div>
        </div>

        <!-- Driver Details -->
        <v-card v-if="trip?.driver" class="mt-3 pa-4" height="90" color="green-lighten-5" rounded="lg" elevation="0">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <v-avatar size="30" class="mr-4 border-sm">
                <v-icon>mdi-account</v-icon>
              </v-avatar>
              <div class="text-start">
                <div class="text-subtitle-2 font-weight-medium">{{ trip?.driver?.name ?? '' }}</div>
                <div class="text-body-2 text-medium-emphasis">{{ trip?.driver?.vehicle_name ?? '' }} {{
                  trip?.driver?.vehicle_model ?? '' }}</div>
                <div class="text-caption text-medium-emphasis">
                  {{ trip?.driver?.vehicle_registration_number ?? '' }}
                </div>
              </div>
            </div>

            <div class="d-flex justify-end mt-4">
              <v-chip size="small">
                {{ trip?.driver?.phone ?? '' }}
              </v-chip>
            </div>
          </div>

          <!-- Buttons -->

        </v-card>

        <v-card v-else-if="trip?.status != 4" class="mt-6 pa-4 d-flex justify-space-between align-center"
          color="yellow-lighten-5" rounded="lg" elevation="0">
          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-4" color="yellow-lighten-4">
              <v-icon class="text-orange-darken-2" size="22">mdi-account-clock</v-icon>
            </v-avatar>
            <div>
              <div class="text-subtitle-2 font-weight-medium">
                Looking for a driver
              </div>
              <div class="text-body-2">
                We'll notify you once a driver is assigned
              </div>
            </div>
          </div>

          <v-btn variant="outlined" class="text-body-2" rounded="lg" @click="cancelBooking(trip)">
            cancel Booking
          </v-btn>
        </v-card>
      </v-card>
      <div v-if="filteredTrips.length === 0" class="empty">
        No {{ currentTab.toLowerCase() }} trips found.
      </div>
    </div>
    <v-dialog v-model="cancelBookingDialog" max-width="500">
      <v-card class="pa-2 rounded-lg">
        <v-card-title class="text-h6 font-weight-medium">
          Cancel Booking
        </v-card-title>

        <v-card-text>
          <p class="mb-3">
            Are you sure you want to cancel this booking?
          </p>

           <v-textarea
          label="Reason for cancellation"
          row-height="25"
          rows="3"
          v-model="reason"
          variant="outlined"
          auto-grow
          required
        ></v-textarea>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="grey-darken-1" variant="text" @click="cancelBookingDialog = false">
            Close
          </v-btn>
          <v-btn color="error" variant="flat" @click="ConfirmCancelBooking" :loading="CancelisLoading">
            Cancel Booking
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AppTrip",
  data() {
    return {
      currentTab: "Incoming",
      tabs: ["Incoming", "Completed", "Canceled"],
      trips: [
      ],
      selectedTrip: null,
      isLoading: true,
      CancelisLoading: false,
      reason: "",
      cancelBookingDialog: false,
    };
  },
  computed: {
    filteredTrips() {
      // if (this.currentTab === 'Incoming') {
      //   return this.trips.filter(trip => trip.status === 2 || trip.status === 8);
      // }
      // else if (this.currentTab === 'Completed') {
      //   return this.trips.filter(trip => trip.status === 3);
      // }
      // else {
        return this.trips.filter(trip => trip.status != 0);
      // }
    },
  },
  mounted() {
    this.getTrips();
  },
  methods: {
    async getTrips() {
      // Get the logged in user ID
      const userId = this.$store.getters['auth/user'].id || 52;

      await axios
        .get(`/bookings?user_id=${userId}`)
        .then(response => {
          this.trips = response.data.data;
          console.log('data', this.trips);
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.error(error);
        });
    },
    cancelBooking(trip) {
      this.cancelBookingDialog = true;
      this.selectedTrip = trip;
    },
    async ConfirmCancelBooking() {
      this.CancelisLoading = true
      let payload = {
        aggregator_id: this.selectedTrip.aggregator_id,
        bookingId: this.selectedTrip.after_booking_id,
        reason: this.reason,
        aggregator_name: this.selectedTrip.aggregator.name,
        user_id: this.selectedTrip.user_id,
        cancelled_by: 1,
        company_id: this.selectedTrip.company_id
      }
      await axios
        .post("/cancel_bookings", payload)
        .then(response => {
          console.log('response', response);
          if (response.data.data?.original?.response?.success == true) {
            this.cancelBookingDialog = false;
            this.getTrips();
          }
          this.CancelisLoading = false
        })
        .catch(error => {
          console.error(error);
          this.CancelisLoading = false
        });
    },
    truncate(text, length = 25) {
      if (!text) return '';
      return text.length > length ? text.slice(0, length) + '...' : text;
    },
    intStatusToString(status) {
      switch (status) {
        case 2:
          return "incoming";
        case 8:
          return "driver assigned";
        case 3:
          return "completed";
        case 4:
          return "canceled";
        default:
          return "unknown";
      }
    },
    formatDateTime(date, time) {
      if (!date || !time) return "";

      // Combine the date & time into a single Date object
      const dt = new Date(`${date}T${time}`);

      const options = {
        month: 'short',   // Aug
        day: 'numeric',   // 5
        hour: 'numeric',  // 10
        minute: '2-digit',// 25
        hour12: true      // PM format
      };

      return dt.toLocaleString('en-US', options).replace(',', ' at');
    }
  },
};
</script>

<style scoped>
.app {
  min-height: 100vh;
  background: #f3f4f6;
  font-family: Arial, sans-serif;
}

/* Header */
.header {
  background: #2563eb;
  color: white;
  padding: 15px 20px;
}

.header h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
}

/* Tabs */
.tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: #e5e7eb;
  color: #374151;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
}

.tab.active {
  background: #2563eb;
  color: white;
}

/* Container */
.container {
  max-width: 800px;
  margin: 20px auto;
  padding: 0 15px;
}

/* Empty state */
.empty {
  text-align: center;
  color: #6b7280;
}

/* Trip list */
.trip-list {
  display: grid;
  gap: 15px;
}

.trip-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.trip-info h2 {
  margin: 0 0 5px;
  font-size: 1.1rem;
  font-weight: 600;
}

.trip-info p {
  margin: 2px 0;
  color: #6b7280;
  font-size: 0.9rem;
}

/* Status tags */
.status {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: capitalize;
}

.status.incoming {
  background: #fef9c3;
  color: #854d0e;
}

.status.completed {
  background: #d1fae5;
  color: #065f46;
}

.driver.assigned {
  background: #d1fae5;
  color: #065f46;
}

.status.canceled {
  background: #fee2e2;
  color: #991b1b;
}
</style>
